/**
 * @description: 八种查询业务组件-基础组建
 * @param {*}
 * @return {*}
 */
export const bizComponentList = [
  /**
   * miniKey type 的别名，名称不能和现有名称重复，不能太长，太长显示会换行，不美观
   * key：业务组件要求的key
   * name:组件名称
   * type：真实类型
   * renderSchmea:false ,默认为input 类型，如果是其他类型需要设置为false 在comps 文件内手写schema
   *
   */
  // { miniKey: 'CxUpload', key: 'CxUpload', name: '客诉复合上传组件' },
  { miniKey: 'busNo', key: '$$BIZ_businessNo', name: '运单号', type: 'input' },
  { miniKey: 'compNo', key: '$$BIZ_complainCaseNo', name: '投诉单号', type: 'input' },
  { miniKey: 'compName', key: '$$BIZ_complainOperatorName', name: '投诉单处理人', type: 'input' },
  { miniKey: 'dName', key: '$$BIZ_driverName', name: '司机姓名', type: 'input' },
  { miniKey: 'pNumber', key: '$$BIZ_driverPlateNumber', name: '车牌号', type: 'input' },
  { miniKey: 'dTel', key: '$$BIZ_driverTel', name: '司机手机号', type: 'input' },
  { miniKey: 'sName', key: '$$BIZ_shipperName', name: '货主姓名', type: 'input' },
  { miniKey: 'sTel', key: '$$BIZ_shipperTel', name: '货主手机号', type: 'input' },
  { miniKey: 'inte', key: 'intention', type: 'select', name: '意向度', renderSchema: false },
  { miniKey: 'neFoTi', key: 'nextFollowupTime', type: 'datetime', name: '设置下次跟进时间', renderSchema: false },
  { miniKey: 'laFoSt', key: 'lastFollowupStatus', type: 'select', name: '设置最新跟进状态', renderSchema: false },
  { miniKey: 'refuelOrder', key: 'refuelOrderId', type: 'input', name: '加油订单号' }
]

export const connector = '$$BIZ_'
